import makeActionCreator from 'src/lib/makeActionCreator';

export const SET_INTERFACE = 'SET_INTERFACE';

export const setInterface = makeActionCreator(SET_INTERFACE);
